module.exports = __webpack_public_path__ + "static/media/filter-up.b3a27472.svg";